/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getMessageContext.defs'
export { main as default } from './getMessageContext.defs'
